import React, { useState, useEffect } from 'react';

// MESSAGES
import ExpiredCardsFormattedMessages from '../../messages/billing/ExpiredCardsFormattedMessages';

// NETWORKING
import useExpiredCardsRequest from '../../requests/ExpiredCardsRequest';

// COMPONENTS
import ExpiredCardTable from '../../components/billing/expired/ExpiredCardTable';
import ExpiredCardTableRow from '../../components/billing/expired/ExpiredCardTableRow';
import Layout from '../../components/layouts/Layout';
import { BillingRoutes } from '../../routes/BillingRoutes';
import Loader from '../../components/common/Loader';

const ExpiredCardsReport = ({
  customer,
  incomingData,
  errorHandler,
  accessLevel,
  accessType,
  saveSessionData,
}) => {
  const { getExpiredCards } = useExpiredCardsRequest();
  const [list, setList] = useState([]);
  const [totals, setTotals] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      if (customer && customer !== null) {
        if (incomingData && incomingData.length !== 0) {
          console.log('Have incoming data:', incomingData);
          // await setState({ data: incomingData.CHANGETHISVARIABLE, dataExists: true });
          formatData(incomingData);
        } else {
          // else if no data, fetch initial set
          let now = new Date();
          let weekAgo = new Date();
          let sevenDays = now.getDate() - 7;
          weekAgo.setDate(sevenDays);
          let toDate = now.getTime();
          let fromDate = weekAgo.getTime();

          const result = await getExpiredCards(fromDate, toDate, errorHandler);
          if (result) {
            const sortedResults = sortList(result);
            setTotals(sortedResults);
            formatData(sortedResults);
          }

          // Save to index for instant retrieval
          // saveSessionData(result, 'trafficInData');
        }
      }
    };

    fetchData();
  }, [customer, incomingData, errorHandler, saveSessionData]);

  const sortList = (data) => {
    return data.sort((a, b) => {
      if (a.customer_name < b.customer_name) return -1;
      if (a.customer_name > b.customer_name) return 1;
      return 0;
    });
  };

  const formatData = (data) => {
    try {
      const formattedList = data.map((el) => (
        <ExpiredCardTableRow
          key={el.customer_id}
          id={el.customer_id}
          account={el.customer_name}
          name={el.cc_name}
          email={el.contact_email}
          phone={el.contact_tn}
          nameOnCard={el.cc_name}
          cardType={el.cc_type}
          cardNumber={el.cc_last_four}
          expiryDate={el.cc_expiry}
        />
      ));
      setList(formattedList);
      setLoading(false);
    } catch (e) {
      console.log('data error:', e);
    }
  };

  const changeEvent = (o) => {
    console.log(o);
  };

  const handlePagination = (page) => page;

  const handleFilter = (startDate, endDate, costFrom, costTo, agent) => {
    console.log(startDate, endDate, costFrom, costTo, agent);
  };

  if (accessLevel === '3' && accessType === '3') {
    return (
      <Layout
        routes={BillingRoutes}
        title={ExpiredCardsFormattedMessages.expiredCardsTitle}
        accessLevel={accessLevel}
        accessType={accessType}
        customerType={customer.customer_type}
        backgroundColor="none"
      >
        {loading ? (
          <Loader />
        ) : (
          <ExpiredCardTable
            list={list}
            handlePagination={handlePagination}
            pageCount={pageCount}
          />
        )}
      </Layout>
    );
  }
  return null;
};

export default ExpiredCardsReport;
